module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_background_image6.62bb2020.svg";